import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery, useQueryClient} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post, del } from "@utils/axios_api";
import { qk } from "@utils/queryKey";

const fetchLectureStudentList = async (params) => {
  const response = await get("/admin/lectureStudent/lectureStudentList", { params });
  return response;
};


export function useLectureStudent(lectureId) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);
  const queryClient = useQueryClient();
  
  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      applyYn: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const applyYn = searchParams.get("applyYn") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd, searchWrd, lectureId, applyYn,
    pageIndex, recordCountPerPage,
  };

  const { data, refetch } = useQuery({
    queryKey: [...qk.studentList(lectureId), JSON.stringify(queryParam)],
    queryFn: () => fetchLectureStudentList(queryParam),
    keepPreviousData: true,
    enabled: !!lectureId
  });



  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("applyYn", values.applyYn || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const handleSelectAll = (e) => {
    if (!data || !data.resultList) return;
    const { checked } = e.target;
    if (checked) {
      const allIds = data.resultList.map((item) => item.memberId);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (memberId) => {
    if (selectedItems.includes(memberId)) {
      setSelectedItems(selectedItems.filter((id) => id !== memberId));
    } else {
      setSelectedItems([...selectedItems, memberId]);
    }
  };
  
  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    methods.reset({
      searchCnd: "",
      searchWrd: "",
      applyYn: "",
    });
    setSearchParams(new URLSearchParams());
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    if (!selectedItems.length) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }

    const hasApplicant = data?.resultList?.some(
      (row) => selectedItems.includes(row.memberId) && row.applyYn === 'Y',
    );
  
    if (hasApplicant) {
      alert('신청자는 관리자에서 삭제할 수 없습니다. 신청관리에서 처리해주세요.');
      return;
    }

    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");
    if (!isConfirmed) return;

    try {
        const response = await del("/admin/lectureStudent/deleteLectureStudent", {data: {memberIdList: selectedItems, lectureId: lectureId}})
        alert(response?.message);
        refetch();
        setSelectedItems([]);

        await queryClient.invalidateQueries({
          predicate: (q) =>
            q.queryKey[0] === "selectLectureStdtModalList" &&
            q.queryKey.includes(lectureId),
        });

        /* 출석부 목록 새로고침 */
        queryClient.invalidateQueries({ queryKey: qk.attendList(lectureId) });
        // queryClient.invalidateQueries(["selectAdminLectureAttend", lectureId]);

      } catch (err) {
        console.error(err);
        alert("삭제 실패");
      }
    
  };



  // 체크 여부
  const isAllChecked = !!(data?.resultList?.length && selectedItems.length === data?.resultList?.length);

  return {
    methods, data,
    selectedItems, isAllChecked, onSubmit,
    handlePageChange, handleSelectAll, handleSelectItem, handleDelete, resetSearch,
    pageIndex, recordCountPerPage,
    refetch, refreshList,
  };
}
